import { render, staticRenderFns } from "./checkSubjectDialog2.vue?vue&type=template&id=2db7806a&scoped=true"
import script from "./checkSubjectDialog2.vue?vue&type=script&lang=js"
export * from "./checkSubjectDialog2.vue?vue&type=script&lang=js"
import style0 from "./checkSubjectDialog2.vue?vue&type=style&index=0&id=2db7806a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7806a",
  null
  
)

export default component.exports